/**
 * Registers /sw.js at origin root. Idempotent per scope — safe under
 * StrictMode double-invocation.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (
    !("serviceWorker" in navigator) ||
    !("PushManager" in window) ||
    !("Notification" in window)
  ) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        // Non-fatal — CRM remains usable without push.
        // eslint-disable-next-line no-console
        console.warn("[pwa] Service worker registration failed:", err);
      });
  });
}
